import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import camelCase from 'lodash/camelCase';

import { useParams } from 'react-router-dom';
import { useOrder } from '../../hooks';

import Panel from 'wonderbly-components/lib/Panel';
import Loading from '../Loading';
import ShippingAddress from './ShippingAddress';
import ShippingInformation from './ShippingInformation';
import OrderBreakdown from './OrderBreakdown';
import OrderTotal from './OrderTotal';

import './OrderDetails.scss';

const OrderDetails = ({ title, items }) => {
  const { orderNumber } = useParams();
  const { data, loading, error } = useOrder(orderNumber);

  const details = items.reduce((result, { type, ...item }) => {
    result[camelCase(type)] = item;
    return result;
  }, {});

  if (error) {
    return null;
  }

  return (
    <section className="order-details">
      <Panel border="shadow">
        <Panel.Section>
          <h4 className="text-mega bold order-details__title">{title}</h4>
        </Panel.Section>
        {loading &&
          <Panel.Section>
            <Loading relative dark small />
          </Panel.Section>
        }
        {!loading &&
          <Fragment>
            {(details.shippingAddress || details.shippingMethod) && (
              <Panel.Section>
                <div className="shipping-summary-wrapper">
                  {details.shippingAddress &&
                    <ShippingAddress
                      className="shipping__item"
                      title={details.shippingAddress.title}
                      address={data.shipping.address}
                    />
                  }
                  {details.shippingMethod &&
                    <ShippingInformation
                      className="shipping__item"
                      title={details.shippingMethod.title}
                      methodType={data.shipping.method.type}
                      delivery={data.shipping.delivery}
                    />
                  }
                </div>
              </Panel.Section>
            )}
            {details.orderBreakdown &&
              <Panel.Section>
                <OrderBreakdown
                  title={details.orderBreakdown.title}
                  breakdown={data.price.breakdown}
                />
              </Panel.Section>
            }
            {details.orderTotal &&
              <Panel.Section>
                <OrderTotal
                  title={details.orderTotal.title}
                  total={data.price.formatted}
                />
              </Panel.Section>
            }
          </Fragment>
        }
      </Panel>
    </section>
  );
};

OrderDetails.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
  })).isRequired
};

export default OrderDetails;



// WEBPACK FOOTER //
// ./src/client/js/view/components/OrderDetails/OrderDetails.js